<script lang="ts" setup>
import { MenuItems } from '@headlessui/vue'

interface Props {
  customClass?: string | null
  static?: boolean
}

withDefaults(defineProps<Props>(), {
  customClass: 'right-6',
  static: false,
})
</script>
<template>
  <transition
    enter-active-class="transition ease-out duration-100"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
  >
    <MenuItems
      :static="static"
      class="absolute z-10 mt-2 w-64 origin-top-right divide-y divide-neutral-200 dark:divide-neutral-500 rounded-md backdrop-blur-xs bg-white/80 dark:bg-neutral-700/80 shadow-lg/20 dark:shadow-lg/60 ring-1 ring-black/5 focus:outline-hidden max-h-96 overflow-y-auto"
      :class="customClass"
    >
      <slot />
    </MenuItems>
  </transition>
</template>
